import React from 'react';
import { useItems, useVisibility } from '../model';
import { BottomMenuContext } from '../model/context';
import { View } from './view';
import { BottomMenuProps } from './model';

export * from './model';
export * from './const';

const BottomMenu: React.FC<BottomMenuProps> = ({ sx, ...restProps }) => {
  const menuContainerRef = React.useRef<HTMLDivElement>(null);
  const { items, isLoading } = useItems({ ...restProps, menuContainerRef });
  const { isVisible } = useVisibility();

  const contextValue = React.useMemo(() => ({ isVisible }), [isVisible]);

  const viewProps = {
    items,
    isLoading,
    isVisible,
    sx,
  };

  return (
    <BottomMenuContext.Provider value={contextValue}>
      <View {...viewProps} ref={menuContainerRef} />
    </BottomMenuContext.Provider>
  );
};
BottomMenu.displayName = 'BottomMenu';

export const BottomMenuWrapper: React.FC<BottomMenuProps> = (props) => {
  return <BottomMenu {...props} />;
};
